/**
 * App-Symbol für die Kacheln im öffentlichen Bereich.
 *
 * Bilder werden weiterhin im Backend gepflegt: bevorzugt `icon_url`,
 * ersatzweise `image_url`. Erst wenn beides fehlt, wird ein neutrales
 * Platzhalter-Symbol im Stil des Layouts gezeichnet.
 */
export default function AppIcon({
  app,
  size = 40,
}: {
  app: { name?: string; icon_url?: string | null; image_url?: string | null }
  size?: number
}) {
  const src = app?.icon_url || app?.image_url

  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        style={{
          width: size,
          height: size,
          objectFit: 'cover',
          borderRadius: 'var(--wc-radius-md)',
          background: 'color-mix(in srgb, var(--wc-text) 6%, transparent)',
          flex: 'none',
        }}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: 'var(--wc-radius-md)',
        border: '1px solid var(--wc-divider)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
      }}
    >
      <svg
        width={Math.round(size * 0.55)}
        height={Math.round(size * 0.55)}
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--wc-accent)"
        strokeWidth="1.5"
      >
        <path
          d="M13 3 4 14h6l-1 7 9-11h-6l1-7z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}
